import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_3 = { class: "fixed z-10 inset-0 overflow-y-auto" }
const _hoisted_4 = { class: "flex items-end sm:items-center justify-center min-h-full p-4 text-center lg:p-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg mb-4 font-bold" }, "Define Your Credit Box", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "p-4 bg-gray-100 text-sm leading-6 text-gray-700 pr-12 rounded" }, " We’re sorry this deal didn’t fit your criteria. Click “OK” to be redirected to your profile page where you can update your credit box so you can see deals that are better matches. ", -1)
const _hoisted_7 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all my-8 max-w-xl w-full p-6",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_link, {
              to: "/account",
              class: "bg-sky text-white text-sm px-4 py-2 rounded-md",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('ModalUpdateCreditBox')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Ok ")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}